// Copyright (c) 2016 Deere & Company

import {
    sharedToggleDealerAccountFacetItems,
    sharedUpdateDealerAccountFacetInput,
    sharedUpdateDealerAccountFacetItem
} from '../../../shared/reducers/facets';
import Facets from '../state/facets';
import {getDefaultState} from '../state';
import {getMatchingObjects} from '../../../shared/services/key-matcher';
import pipActions from '../../actions-list';
import {updateList} from '../../../shared/services/list-selections';
import userActions from '../../../user/actions-list';
const actions = {
    ...pipActions,
    ...userActions
};
const defaultPipTypeKeys = ['MALF', 'SAFT'];
const defaultMetrics = ['Y'];

const readMetrics = (state, action) =>
    Facets.update(state, {
        metricsFacet: {
            $merge: {
                allowedMetrics: action.data,
                isInitialLoad: false,
                selectedMetrics: getMatchingObjects(defaultMetrics, action.data)
            }
        }
    });

const readPipTypes = (state, action) =>
    Facets.update(state, {
        pipTypesFacet: {
            $merge: {
                allowedTypes: action.data,
                isInitialLoad: false,
                selectedTypes: getMatchingObjects(defaultPipTypeKeys, action.data)
            }
        }
    });

const resetAllFacets = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            displayedDealers: {
                $set: action.dealerAccounts
            },
            searchInput: {
                $set: ''
            },
            selectedDealers: {
                $set: action.dealerAccounts
            }
        },
        metricsFacet: {
            selectedMetrics: {
                $set: getMatchingObjects(defaultMetrics, action.metrics)
            }
        },
        pipTypesFacet: {
            selectedTypes: {
                $set: getMatchingObjects(defaultPipTypeKeys, action.pipTypes)
            }
        }
    });

const toggleOpenPipDealerAccountFacetItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedToggleDealerAccountFacetItems(state.dealerAccountsFacet, action)
        }
    });

const togglePipTypeFacetItems = (state, action) => {

    const updatedSelectedTypes = state.pipTypesFacet.selectedTypes.length ?
        [] :
        action.allowedTypes;

    return Facets.update(state, {
        pipTypesFacet: {
            selectedTypes: {
                $set: updatedSelectedTypes
            }
        }
    });

};

const toggleMetricsFacetItems = (state, action) => {

    const updatedSelectedMetrics = state.metricsFacet.selectedMetrics.length ?
        [] :
        action.allowedMetrics;

    return Facets.update(state, {
        metricsFacet: {
            selectedMetrics: {
                $set: updatedSelectedMetrics
            }
        }
    });

};

const updateDealerAccountFacetInput = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetInput(state.dealerAccountsFacet, action)
        }
    });

const updateDealerAccountFacetItem = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetItem(state.dealerAccountsFacet, action)
        }
    });

const updateMetricFacetItem = (state, action) =>
    Facets.update(state, {
        metricsFacet: {
            selectedMetrics: {
                $set: updateList(
                    action.metric,
                    action.isSelected,
                    'key',
                    state.metricsFacet.selectedMetrics
                )
            }
        }
    });

const updatePipTypeFacetItem = (state, action) =>
    Facets.update(state, {
        pipTypesFacet: {
            selectedTypes: {
                $set: updateList(
                    action.pipType,
                    action.isSelected,
                    'key',
                    state.pipTypesFacet.selectedTypes
                )
            }
        }
    });

const updateDealerAccountItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $merge: {
                allowedDealers: action.allowedDealers,
                displayedDealers: action.allowedDealers,
                isInitialLoad: false,
                selectedDealers: action.allowedDealers
            }
        }
    });

const updateDealers = state =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {
                $set: true
            }
        }
    });

export default (state = getDefaultState().facets, action) => {

    const actionTypes = {
        [actions.READ_METRICS_SUCCESS]: readMetrics,
        [actions.READ_PIP_TYPES_SUCCESS]: readPipTypes,
        [actions.RESET_OPEN_PIP_PRODUCTS_FILTERS]: resetAllFacets,
        [actions.TOGGLE_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS]: toggleOpenPipDealerAccountFacetItems,
        [actions.TOGGLE_OPEN_PIP_PRODUCTS_METRICS_FACET_ITEMS]: toggleMetricsFacetItems,
        [actions.TOGGLE_OPEN_PIP_PRODUCTS_PIP_TYPE_FACET_ITEMS]: togglePipTypeFacetItems,
        [actions.UPDATE_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_INPUT]: updateDealerAccountFacetInput,
        [actions.UPDATE_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEM]: updateDealerAccountFacetItem,
        [actions.UPDATE_OPEN_PIP_PRODUCTS_METRIC_FACET_ITEM]: updateMetricFacetItem,
        [actions.UPDATE_OPEN_PIP_PRODUCTS_PIP_TYPE_FACET_ITEM]: updatePipTypeFacetItem,
        [actions.UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS]: updateDealers,
        [actions.UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS]: updateDealers,
        [actions.SELECT_ALL_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS]: updateDealerAccountItems
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/open-pips/reducers/facets.js